interface ODataPageResponse {
    value?: unknown[] | null;
    "@odata.count"?: number | null;
}

export const getODataNextPageParam = <TPage extends ODataPageResponse>(
    _lastPage: TPage,
    allPages: TPage[]
): number | undefined => {
    const total = allPages[0]?.["@odata.count"] ?? 0;
    const loaded = allPages.reduce((sum, page) => sum + (page.value?.length ?? 0), 0);

    return loaded < total ? loaded : undefined;
};

export const odataSkipPagination = {
    toPageQuery: (pageParam: number) => ({ $skip: pageParam }),
    initialPageParam: 0,
    getNextPageParam: getODataNextPageParam
};
